import { getAuthRoot } from '../../../store/rootSelector';
import { ApplicationState } from '../../../store/types';

export const getLoginRoot = (state: ApplicationState) => getAuthRoot(state).login;
export const getRegistrationRoot = (state: ApplicationState) => getAuthRoot(state).registration;
export const getResetPasswordRoot = (state: ApplicationState) => getAuthRoot(state).resetPassword;
export const getNotificationsRoot = (state: ApplicationState) => getAuthRoot(state).notification;
